import React from 'react';
const sections = [{
  name: 'מאמרים',
  count: '42'
}, {
  name: 'ראיונות',
  count: '18'
}, {
  name: 'תרבות',
  count: '36'
}, {
  name: 'מחשבה',
  count: '24'
}, {
  name: 'שירה',
  count: '12'
}, {
  name: 'ביקורת',
  count: '29'
}];
export function SectionsGrid() {
  return <section className="px-4 md:px-8 py-16 border-b border-ink/20 bg-paper-deep" data-id="element-152">
      <div className="max-w-7xl mx-auto" data-id="element-153">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-ink/10 border border-ink/10" data-id="element-154">
          {sections.map((section, i) => <a key={i} href={`#${section.name}`} className="bg-paper-deep p-6 md:p-8 flex flex-col items-center justify-center gap-2 hover:bg-paper transition-colors group" data-id="element-155">
              <span className="font-serif text-2xl md:text-3xl font-bold text-ink group-hover:text-vermillion transition-colors" data-id="element-156">
                {section.name}
              </span>
              <span className="font-sans text-xs text-ink-soft/60" data-id="element-157">
                {section.count} רשומות
              </span>
            </a>)}
        </div>
      </div>
    </section>;
}